/* 介面偏好：UI 縮放、畫面震動強度、傷害數字。

   **另開一個 localStorage key 而不是塞進 META**：`platform/storage.ts` 的
   `loadMeta` 只覆蓋既有的欄位，新增欄位要同步改 `SAVE_KEY` 版號，
   而那會讓所有玩家的局外進度重置 —— 為了三個介面開關不值得。

   三個值都**只影響呈現**，不進模擬快照、不影響決定性。 */

var KEY = 'chassis0:ui:v1';

export var UIPREF = {
  /* 整個 `#ui` 的 zoom。預設 1.15 是使用者 2026-08-03 訂的（style.css 的 --ui-scale），
     這裡只是讓玩家能在小螢幕上調小、在 4K 上調大。 */
  scale: 1.15,
  /* 畫面震動的乘數。0 = 完全關掉（暈動症），1 = 原本的力道。
     套用點在 `sim/camera.ts` 讀 `STATE.shake` 的那一行 —— 不改 `STATE.shake`
     本身，所以快照與決定性完全不受影響。 */
  shake: 1,
  /* 傷害數字。關掉之後 `sim/fx.ts` 的 `popDmg` 直接 return，
     但**治療與提示文字仍然會出**（那是狀態回饋不是數字噪音）。 */
  dmgNum: true,
};

export function saveUIPrefs() {
  try { localStorage.setItem(KEY, JSON.stringify(UIPREF)); } catch (e) { /* 無痕模式 */ }
}

/** 把偏好套到畫面上。改任何一項之後都要呼叫。 */
export function applyUIPrefs() {
  if (typeof document === 'undefined' || !document.documentElement) return;
  document.documentElement.style.setProperty('--ui-scale', String(UIPREF.scale));
}

export function loadUIPrefs() {
  try {
    var raw = localStorage.getItem(KEY);
    if (raw) {
      var o = JSON.parse(raw);
      /* 只讀認得的鍵，而且逐項夾範圍 —— 存檔是使用者可以手改的，
         `--ui-scale: 40` 會讓整個介面撐爆而且**沒有任何畫面能點回去改**。 */
      if (typeof o.scale === 'number') UIPREF.scale = Math.max(0.8, Math.min(1.6, o.scale));
      if (typeof o.shake === 'number') UIPREF.shake = Math.max(0, Math.min(1.5, o.shake));
      if (typeof o.dmgNum === 'boolean') UIPREF.dmgNum = o.dmgNum;
    }
  } catch (e) { /* 壞掉的存檔就用預設值 */ }
  applyUIPrefs();
}
